import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-company',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './company.html',
  styleUrl: './company.css',
})
export class CompanyComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'Company',
      description: 'About Tech Colleagues and the orderYaa ERP platform.',
      path: '/company',
    });
  }
}
